import SeoHead from '../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SubBanner from '../../components/SubBanner';
import Clients from '../../components/Clients';
import OurValues from '../../components/OurValues';
import SimpleTwoColumns from "../../components/SimpleTwoColumns";
import Header from '../../components/MainHeader';
import VideoGrid from '../../components/VideoGrid';

export default function JobSearchbyClient({
    global,
    all_clients,
    all_video_testimonials,
}) {
    return (
        <>
            <SeoHead
                page_name={`Video Testimonials | Gap Personnel`}
                canonical_link={`/video-testimonials/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`video_testimonials.heading`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`Video Testimonials`}
                bannerImage="/site-assets/images/video-testimonials.png"
                bannerImageAlt="Video Testimonials by client"
            />
            <SimpleTwoColumns
                global={global}
                pathPrefix={`video_testimonials.content`}
                customClass={`mb-5 text-center`}
                content1={`Premdor is one of the UK's leading manufacturers of timber doors. They supply both interior and exterior doors and their extensive range also includes everything from French and folding doors to doorsets. Their products benefit from almost 90 years of experience in door and joinery manufacturing. Premdor was the first joinery manufacturer to produce and sell moulded panel doors in the UK and, as a result, they have gained an unrivalled reputation for offering new joinery solutions to the market.`}
                content2={``}
            />
            <VideoGrid
                global={global}
                customClass='text-center mb-5 pb-5'
                post={all_video_testimonials}
                content={
                    <h3>Video Testimonials</h3>
                }
            />
            <OurValues
                global={global}
                pathPrefix={`job_search_by_client_page.our_values`}
                customClass='mb-5'
                sub_heading_1={`Consultative`}
                sub_heading_2={`Accountable`}
                sub_heading_3={`Real`}
                sub_heading_4={`Ethical`}
                sub_heading_5={``}
                content_1={`It’s right there in the job title, ‘Recruitment Consultant’. We want to understand exactly what you’re looking for in your next role; your salary expectations, where you can travel to, shift patterns that will work for you. Only by consulting with you can we find you a role that fits your wants and needs.`}
                content_2={`If we say we’ll do it, then we’ll do it. Got a query? If we don’t already have the answer we’ll find out and get back to you. Is something not quite working out with your job role? We want to know so we can try and resolve it.`}
                content_3={`We want to get to know you so we can support you personally. By being approachable and responsive we will build a real relationship with you so we can have open and honest conversations.`}
                content_4={`We have lots of compliance processes in place to safeguard the welfare of our workers, but more it’s more than that - we promise to always be totally transparent. You’ll know every detail of any placement on offer before you agree to it, and if it’s not for you there’ll be no pressure from us.`}
                content_5={``}
                heading={`Our Values`}
                imageSrc1={`/site-assets/images/consultative-icon.jpg`}
                imageSrc2={`/site-assets/images/accountable-icon.jpg`}
                imageSrc3={`/site-assets/images/real-icon.jpg`}
                imageSrc4={`/site-assets/images/ethical-icon.jpg`}
                imageSrc5={``}
                imageAlt1={`Consultative`}
                imageAlt2={`Accountable`}
                imageAlt3={`Real`}
                imageAlt4={`Ethical`}
                imageAlt5={``}
                displayOnDefault={true}
            />
            <Clients
                global={global}
                pathPrefix={`job_search_by_client_page.all_clients`}
                all_clients={all_clients}
                customClass={`pt-lg-5 mt-lg-5`}
                heading={`Accreditations and partnerships`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const clients = await Collection('accreditations');
    const video_testimonials = await Collection('video_testimonials');

    const all_clients = clients.orderBy('order').getItems();
    const all_video_testimonials = video_testimonials.orderBy('order').getItems();

    return {
        props: {
            global,
            all_clients,
            all_video_testimonials,
        },
    }
}
